<script>
import {Icon} from '@iconify/vue/dist/iconify';

/* COMPOSANTS */
import AkCalendar from '@components/input/AkCalendar.vue';
import AkInputText from '@components/input/AkInputText.vue';

/* MIXINS */
import utilsMixin from '@mixins/utilsMixin';
import sidebarMixin from '@mixins/sidebarMixin';

/* SERVICES */

export default {
  components: {
    AkInputText,
    AkCalendar,
    Icon,
  },
  mixins: [utilsMixin, sidebarMixin],
  props: {
    modelValue: {required: true},
    callback: {
      type: Array,
      required: false,
      default: undefined,
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    search() {
      this.callback[0]();
      this.hideSidebar();
    },
    reset() {
      this.callback[1]();
    },
  },
  computed: {
    currentValue: {
      get: function () {
        return this.modelValue;
      },
      set: function (val) {
        this.$emit('update:modelValue', val);
      },
    },
  },
};
</script>

<template>
  <h2>Filtrer</h2>
  <form class="d-flex flex-column" style="row-gap: 16px" @submit.prevent="search">
    <AkInputText
      ref="inputSearchNumVirement"
      v-model="currentValue.numVirement"
      :label="$t('visitor_tax.transfert_num')"
      :title="$t('visitor_tax.transfert_num')"
      :inline="true"
      class-name="flex-1" />
    <AkCalendar
      ref="inputSearchDate"
      v-model="currentValue.date"
      :label="$t('operation.date')"
      date-format="dd/mm/yy"
      selection-mode="single"
      :title="$t('operation.date')"
      :inline="true"
      class-name="flex-1" />

    <div class="d-flex flex-row">
      <button class="btn btn-primary btn-search flex-1" type="submit">
        {{ this.$t('visitor_tax.filter') }}
      </button>
      <Icon
        v-on:click="this.reset()"
        class="pointer"
        icon="basil:cross-outline"
        :style="{fontSize: '50px', width: '50px !important'}" />
    </div>
  </form>
</template>
